/**
 * Return a string with capital first letter
 * @param str - input string
 * @returns string with capital first letter
 */
export const capitalizeFirstLetter = (str) => (str.trim().charAt(0).toUpperCase() + str.trim().slice(1));
